import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ROUTES_CONFIG } from '@/config/routesConfig';
import Layout from '@/layout/layout';
import { usePermissionRoutes } from '@/hooks/usePermissionRoutes';
import PermissionRoute from '@/components/PermissionRoute';
import LayoutLoading from '@/layout/layoutLoading';

const AppRoutes: React.FC = () => {
  const { routes: permissionRoutes, loading } = usePermissionRoutes();
  if (loading) {
    return <LayoutLoading />;
  }

  return (
    <Routes>
      {ROUTES_CONFIG.map((route) => {
        const RouteElement = (
          <PermissionRoute route={route} permissionRoutes={permissionRoutes} />
        );

        return (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.noLayout ? RouteElement : <Layout>{RouteElement}</Layout>
            }
          />
        );
      })}
    </Routes>
  );
};

export default AppRoutes;
